export type CreateExpectedErrorParams = {
  serverErrorCode?: string;
  errorMessage?: string;
  errorData?: any;
};

export type ExpectedError = CreateExpectedErrorParams & {
  __isExpectedError: true;
};

export const createExpectedError = (
  params: CreateExpectedErrorParams
): ExpectedError => ({
  __isExpectedError: true,
  ...params,
});

export const isExpectedError = (error: any): boolean =>
  error?.__isExpectedError === true;
